import { MenuItem, styled } from '@material-ui/core';

const InlineMenuItem = styled(MenuItem)(() => ({
  display: 'inline',
}));

export default InlineMenuItem;
